import React, { useState } from "react";
import {
  Dialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
  withStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import styles from "./styles";
import CustomButton from "../../../../Component/CustomButton";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ExportSelectorDialog = ({ classes, isOpen, onClose, onSubmit }) => {
  const [exportType, setExportType] = useState("standalone");
  const { t } = useTranslation();

  const handleSubmit = () => {
    onSubmit(exportType);
  };

  return (
    <Dialog
      disableBackdropClick
      onClose={onClose}
      aria-labelledby="export-options-dialog"
      open={isOpen}
      scroll="paper"
      maxWidth="lg"
      /* fullWidth={true} */
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle id="export-options-dialog" onClose={onClose}>
        <Typography className={classes.panelTitle}>
          {t("labels.record.exportDialog.header")}
        </Typography>
      </DialogTitle>
      <DialogContent dividers style={{ overflowX: "hidden" }}>
        <Grid container>
          <Grid item>
            <RadioGroup
              size="small"
              margin="dense"
              aria-label="Export Type"
              name="exportType"
              value={exportType}
              onChange={(e) => setExportType(e.target.value)}
            >
              <FormControlLabel
                value="standalone"
                control={<Radio color="primary" />}
                label={t("labels.record.exportDialog.options.standalone")}
                labelPlacement="end"
              />

              <FormControlLabel
                value="attachments"
                control={<Radio color="primary" />}
                label={t("labels.record.exportDialog.options.attachments")}
                labelPlacement="end"
              />

              <FormControlLabel
                value="complete"
                control={<Radio color="primary" />}
                label={t("labels.record.exportDialog.options.complete")}
                labelPlacement="end"
              />
            </RadioGroup>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CustomButton variant="secondary" onClick={handleSubmit}>
          {t("labels.record.exportDialog.actions.export")}
        </CustomButton>
        
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles, { withTheme: true })(ExportSelectorDialog);
